import React, { useCallback, useEffect, useState } from "react";
import { Bar, HorizontalBar } from "react-chartjs-2";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { Skeleton } from "antd";
import moment from "moment";

import partnersApi from "../../apis/Partners.api";

const UserAnalysis = () => {
	const user = useSelector((state) => state.auth.user);
	const [loading, setLoading] = useState(false);

	const [genderPercent, setGenderPercent] = useState({
		female: 0,
		male: 0,
	});

	const [userList, setUserList] = useState([]);
	// const [unknownList, setUnknownList] = useState([]);

	const [mediaResult, setMediaResult] = useState(null);
	useEffect(() => {
		if (typeof window !== "undefined") {
			const matchQueryList = window.matchMedia("all and (max-width: 768px)");
			setMediaResult(matchQueryList.matches);

			const media = function handleChange(e) {
				setMediaResult(e.matches);
			};

			matchQueryList.addEventListener("change", media);
		}
	}, []);

	useEffect(() => {
		if (user?.id) {
			const timer = setTimeout(() => {
				getUserCount();
			}, 100);
			return () => clearTimeout(timer);
		}
		return () => {
			setLoading(false);
		};
	}, [user]);

	const getUserCount = useCallback(async () => {
		setLoading(true);
		const param = {
			endDate: moment().endOf("days").format("YYYYMMDDHHmm"),
			userId:
				user?.role === "level_1" || user?.role === "super_admin"
					? user?.id
					: user?.partners_id,
		};
		const res = await partnersApi.readSignUpUserCount(param);
		if (res.code === 200) {
			if (res.result?.userCount) {
				let all = res.result?.femaleCount + res.result?.maleCount;
				setGenderPercent({
					female: (res.result?.femaleCount / all) * 100,
					male: (res.result?.maleCount / all) * 100,
				});
			}
			let list = res.result?.userSummaryList;
			// let unknown = list.splice(10, 1);
			setUserList(list);
			// setUnknownList(unknown);
		} else {
			setUserList([]);
		}
		setLoading(false);
	}, [user]);

	const options = {
		responsive: true,
		// aspectRatio: 0.1,
		maintainAspectRatio: false,
		legend: {
			position: "top",
			align: "center",
			display: false,
		},
		tooltips: {
			intersect: false,
			// callbacks: {
			//     label: function(tooltipItem, data) {
			//         let value = data.datasets[0].data[tooltipItem.index];
			//         let label = data.datasets[tooltipItem.index].label;
			//         console.log(data, label);
			//         return value.toLocaleString() + '명';
			//     }
			// }
		},
		scales: {
			yAxes: [
				{
					scaleLabel: {
						display: mediaResult,
					},
					ticks: {
						display: mediaResult, // it should work
					},
					gridLines: {
						display: false,
					},
				},
			],
			xAxes: [
				{
					scaleLabel: {
						display: !mediaResult,
					},
					ticks: {
						display: !mediaResult, // it should work
					},
					gridLines: {
						display: false,
					},
				},
			],
		},
	};

	const data = {
		type: "horizontalBar",
		labels: userList?.map((item) => item.distribution_key),
		datasets: [
			{
				barPercentage: 0.6,
				label: "여성",
				data: userList?.map((item) => item.femaleCount),
				backgroundColor: "#ff8000",
				borderWidth: 1,
			},
			{
				barPercentage: 0.6,
				label: "남성",
				data: userList?.map((item) => item.maleCount),
				backgroundColor: "#117ffa",
				borderWidth: 1,
			},
		],
	};

	return (
		<div className={`dashboard-component`} style={{ width: "100%" }}>
			<div className={`user-analysis-component`}>
				<h3>구독자 분석</h3>
				<div
					style={{
						display: "flex",
						alignItems: "center",
						gap: 5,
					}}
				>
					<div className={`user-gender-div`}>
						<div className={`gender-point female`} />
						<p>{genderPercent.female.toFixed(1) ?? 0}% 여성</p>
					</div>
					<div className={`user-gender-div`}>
						<div className={`gender-point male`} />
						<p>{genderPercent.male.toFixed(1) ?? 0}% 남성</p>
					</div>
				</div>
			</div>

			<div
				style={{
					position: "relative",
					width: "100%",
					height: mediaResult ? "50vh" : "20vh",
					padding: mediaResult ? "" : "1.5em 0 0",
				}}
			>
				{loading ? (
					<Skeleton.Button
						loading={loading}
						active={loading}
						size={"large"}
						block={true}
						style={
							mediaResult
								? {
										height: "50vh",
								  }
								: {
										height: "15vh",
								  }
						}
						title={null}
					/>
				) : (
					<>
						{mediaResult ? (
							<HorizontalBar options={options} data={data} />
						) : (
							<Bar options={options} data={data} />
						)}
					</>
				)}
			</div>

			<div className={`dashboard-component-footer`}>
				<Link to={`/user_manage`} className={`dashboard-footer-font`}>
					회원관리로 이동
				</Link>
			</div>
		</div>
	);
};

export default UserAnalysis;
